module.exports = __webpack_public_path__ + "img/pdf_head03.0ccb1b2b.jpg";